var exports = {
  "E": "Text__4-72cZ",
};

module.exports = exports;
